import React, { FC } from 'react';
import { AllieText } from '../../../components/Text';
import { AllieWifiOffGenericIcon } from '../../../styling/icons/Icons';
import { AllieButton } from '../../../components';
import {
  ErrorGenericContainer,
  IconWrapper,
  TextContainer,
  ButtonContainer,
} from './ConnectionErrorGeneric.MobileApp.styles';

export interface ConnectionErrorGenericProps {
  title: string;
  subtitle: string;
  retryButtonText: string;
  onRetry: () => void;
  isRetrying?: boolean;
}

/**
 * Generic Connection Error component for full-page network error states
 * Used in Queries (Conversaciones), Canales, and Horarios views
 * Based on Mockup 3
 */
export const ConnectionErrorGenericMobileApp: FC<ConnectionErrorGenericProps> = ({
  title,
  subtitle,
  retryButtonText,
  onRetry,
  isRetrying = false,
}) => {
  return (
    <ErrorGenericContainer>
      <IconWrapper>
        <AllieWifiOffGenericIcon 
          allieColor="neutral-20" 
          style={{ width: '239px', height: '239px' }} 
        />
      </IconWrapper>
      
      <TextContainer>
        <AllieText type="h3" weight={600} color="neutral-90">
          {title}
        </AllieText>
        <AllieText type="body1" weight={400} color="neutral-70">
          {subtitle}
        </AllieText>
      </TextContainer>

      <ButtonContainer>
        <AllieButton
          allieType="subtle"
          onclick={onRetry}
          allieColor="neutral"
          allieSize="small"
          corner="rounded-edges-plus"
          loading={isRetrying}
        >
          {retryButtonText}
        </AllieButton>
      </ButtonContainer>
    </ErrorGenericContainer>
  );
};
